module.exports = __webpack_public_path__ + "static/media/cold-prey.8d60b960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/cold-prey.jpg
// module id = 278
// module chunks = 0